import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IntersectionObserverModule } from 'src/core-lib/intersection-observer/intersection-observer.module';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarModule } from 'src/core-lib/var/var.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { BreadcrumbsModule } from 'src/layout/breadcrumbs/breadcrumbs.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { PaginationModule } from 'src/layout/pagination/pagination.module';
import { CatalogFormComponent } from './components/catalog-form/catalog-form.component';
import { CatalogSearchLayoutComponent } from './components/catalog-search-layout/catalog-search-layout.component';
import { CatalogSearchComponent } from './components/catalog-search/catalog-search.component';
import { ProductInspirationComponent } from './components/product-inspiration/product-inspiration.component';
import { FacetGroupKeyPipe } from './pipes/facet-group-key.pipe';
import { FacetValuesValuePipe } from './pipes/facet-values-value.pipe';
import { FormReadyPipe } from './pipes/form-ready.pipe';
import { InspirationPositionPipe } from './pipes/inspiration-position.pipe';
import { SkeletonPipe } from './pipes/skeleton.pipe';
import { SplashesPipe } from './pipes/splashes.pipe';


@NgModule({
    declarations: [
        ProductInspirationComponent,
        InspirationPositionPipe,
        SplashesPipe,
        FacetGroupKeyPipe,
        FacetValuesValuePipe,
        FormReadyPipe,
        CatalogSearchComponent,
        SkeletonPipe
    ],
    imports: [
        VarModule,
        CommonModule,
        BreadcrumbsModule,
        GridModule,
        TranslateModule,
        PipeModule,
        MediaModule,
        NavigationModule,
        IntersectionObserverModule,
        ReactiveFormsModule,
        PaginationModule,
        TagManagerModule,
        CatalogFormComponent,
        CatalogSearchLayoutComponent,
    ],
    exports: [
        ProductInspirationComponent,
        InspirationPositionPipe,
        SplashesPipe,
        CatalogSearchLayoutComponent,
        FacetGroupKeyPipe,
        FacetValuesValuePipe,
        FormReadyPipe,
        CatalogSearchComponent,
        SkeletonPipe,
        VarModule,
        CommonModule,
        BreadcrumbsModule,
        GridModule,
        TranslateModule,
        PipeModule,
        MediaModule,
        NavigationModule,
        IntersectionObserverModule,
        ReactiveFormsModule,
        PaginationModule,
        TagManagerModule,
        CatalogFormComponent,
    ]
})
export class CatalogPageModule {
}
